export default [
  {
    id: 'event',
    name: 'Standard',
  },
  {
    id: 'event-variable',
    name: 'Event Variable',
  },
];
